import React, {FC} from "react";
import {toTime} from "../../../../lib/date";
import {UserPatrol} from "../../../../domain/patrol/Patrol";

type Props = {
    item: UserPatrol;
};

export const PatrolRowTimestamp: FC<Props> = ({item}) => {
    const {timestamp} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>REGISTRADO EL</span>
            <span>{toTime(timestamp)}</span>
        </div>
    );
};
